
//Import React Hooks
import { useEffect, useState } from 'react'

//Import MUI componenets
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

//Import created components
import Journee from '../../components/journee/Journee.jsx'
import JourneeManager from '../../components/journeemanager/JourneeManager.jsx'

// tools and component for date picker
import dayjs from 'dayjs';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

//Translate utils :
import { translator } from "../../utils/translator.js"
import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

//import fr from 'dayjs/locale/fr';
const fr = require('dayjs/locale/fr')
dayjs.locale(fr);

console.log(fr);

const weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)

/* const localeData = require('dayjs/plugin/localeData')
dayjs.extend(localeData)

dayjs.locale('fr') */



function Week({ date, manager }) {
    /* useEffect(() => {
       setHousesList(listJson)
    }, []) */

    //console.log(dayjs("2024-05-27").weekday());

    const [dateRef, setDateRef] = useState(date)
    let jourSemaine = 1;
    const semaineList = [1, 2, 3, 4, 5, 6, 7]

    // detect if displayed week is current Week, to prevent navigate before
    let premiereSemaine = dateRef.weekday(0).isBefore(dayjs()) || dateRef.weekday(0).isSame(dayjs(), 'day');

    /*  const globalLocaleData = dayjs.localeData();
     globalLocaleData.firstDayOfWeek(1); */

    const lang = useSelector(getLang) //global state : language

    return (
        <div>
            <main className="calendar">
                <div className="calendar-header">
                    <div className="calendar-header-nav">
                        {<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                            <DatePicker
                                sx={{
                                    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { border: '1px solid #34B0EE' },                               // at page load
                                    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: '2px solid #362782' },  // at hover state
                                }}
                                value={dayjs(dateRef)}
                                label={translator("Choisissez une date", lang, "weekPick")}
                                size="small"
                                minDate={manager === false ? dayjs() : null}
                                onChange={(newValue) => setDateRef(dayjs(newValue))}
                                className='calendar-header-date-picker'
                            />
                        </LocalizationProvider>}
                        {premiereSemaine === true && manager === false ?
                            <KeyboardDoubleArrowLeftIcon className="calendar-header-nav-arrow-disabled" />
                            :
                            <KeyboardDoubleArrowLeftIcon className="calendar-header-nav-arrow" onClick={_ => setDateRef(dateRef.subtract(7, 'day'))} />
                        }
                        <p> {`${translator("du", lang, "weekDu")} ${dateRef.weekday(0).format('DD/MM/YYYY')} \n ${translator("au", lang, "weekAu")} ${dateRef.weekday(6).format('DD/MM/YYYY')}`}</p>
                        <KeyboardDoubleArrowRightIcon className="calendar-header-nav-arrow" onClick={_ => setDateRef(dateRef.add(7, 'day'))} />
                    </div>


                </div>
                <div className="calendar-days">
                    {semaineList.map((jour) => (
                        manager === true ?
                            <JourneeManager key={jour} nbjour={jour} date={dateRef.weekday(jour - 1)} />
                            :
                            <Journee key={jour} nbjour={jour} date={dateRef.weekday(jour - 1)} />

                    )
                    )}
                </div>
            </main>
        </div>
    );
}

export default Week;